import React, { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { MenuClient } from "../MenuClient"
import { Header } from "../../common/header/Header"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { useParams } from "react-router-dom"
import { BasisTab } from "./tabs/BasisTab"
import { IReplenishmentDto } from "../../../types/replenishment/IReplenishmentDto"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { IErrorModel } from "../../../types/error/IErrorModel"
import { ContractorTab } from "./tabs/ContractorTab"
import { DocsTab } from "./tabs/DocsTab"
import { CRTab } from "./tabs/CRTab"
import { PaymentTab } from "./tabs/PaymentTab"

export const ReplenishmentClient = () => {
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [errors, setErrors] = useState<IErrorModel>()
  const params = useParams()
  const [stage, setStage] = useState<string | undefined>()
  const [replenishment, setReplenishment] = useState<IReplenishmentDto>({ stage: "BASIS" })
  const [sending, setSending] = useState(false)

  useEffect(() => {
    if (params.id !== "new") {
      TrinityAPI.getReplenishment(Number(params.id), response => {
        if (response.status === 200) {
          setReplenishment(response.data)
          setStage(response.data.stage)
        }
      })
    } else {
      setStage("BASIS")
    }
  }, [])

  const submitBasis = () => {
    if (sending) {
      return
    }
    setSending(true)
    TrinityAPI.submitBasis(replenishment, response => {
      if (response.status === 200) {
        window.location.href = `/replenishment/${response.data.id}`
      } else {
        setErrors(response.data)
        setSending(false)
      }
    })
  }

  const submitContractor = () => {
    if (sending) {
      return
    }
    setSending(true)
    TrinityAPI.submitContractor(replenishment, response => {
      if (response.status === 200) {
        setReplenishment(response.data)
        setStage("DOCS")
        setSending(false)
        setErrors(undefined)
      } else {
        setErrors(response.data)
        setSending(false)
      }
    })
  }

  const submitDocs = () => {
    if (sending) {
      return
    }
    setSending(true)
    TrinityAPI.submitDocs(replenishment, response => {
      if (response.status === 200) {
        window.location.reload()
      } else {
        setErrors(response.data)
        setSending(false)
      }
    })
  }

  const crAcceptance = (accepted: boolean) => {
    if (!replenishment.id) return
    TrinityAPI.crConfirmation(replenishment.id, accepted, response => {
      if (response.status === 200) {
        window.location.reload()
      } else {
        setModalMessage({ title: "Ошибка!", text: `Произошла ошибка отправки запроса: ${response.data.message}` })
      }
    })
  }

  const rejectPayment = () => {
    crAcceptance(false)
  }

  const submitBill = (r: IReplenishmentDto) => {
    TrinityAPI.submitPayment(r, response => {
      if (response.status === 200) {
        window.location.reload()
      } else {
        if (response.data.code === "000-000") {
          setErrors(response.data)
        } else {
          setModalMessage({
            title: "Ошибка!",
            text: `Произошла ошибка при отправке платежного поручения: ${response.data.message}`
          })
        }
      }
    })
  }

  const isPickable = (item: string) => {
    switch (item) {
      case "DOCS":
        return !!replenishment.status
      case "CONTRACTOR":
        return !!replenishment.status
      case "COMPANY":
        return replenishment.status && replenishment.status !== "NEW" && replenishment.status !== "DOC_NAC"
      case "CR":
        return (
          replenishment.status &&
          replenishment.status !== "NEW" &&
          replenishment.status !== "DOC_NAC" &&
          replenishment.status !== "DOC"
        )
      case "PAYMENT":
        return (
          replenishment.status &&
          (replenishment.status === "BILL" ||
            replenishment.status === "CR_ACC" ||
            replenishment.status === "BILL_PAID" ||
            replenishment.status === "DONE" ||
            replenishment.status === "CR_FIX")
        )
      case "CR_FIX":
        return replenishment.status === "DONE"
    }
  }

  const getItemClazz = (item: string) => {
    if (item === "CR_FIX" && stage === "CR_FIX" && replenishment.status === "DONE") {
      return "deals-stage-item-active"
    } else if (item === "CR_FIX") {
      return !isPickable(item) ? "deals-stage-item-lock" : "deals-stage-item"
    }
    if (item === "PAYMENT" && replenishment.status === "CR_FIX" && (stage === "PAYMENT" || stage === "CR_FIX")) {
      return "deals-stage-item-active"
    }
    if (item === stage) {
      return "deals-stage-item-active"
    } else {
      return !isPickable(item) ? "deals-stage-item-lock" : "deals-stage-item"
    }
  }

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <MenuClient active={"replenishment"} />
      <section className="deals-info" style={{ display: "block" }}>
        <Header clazzName={"header-main-deals"} />
        <div className="container">
          <h1 className="ui-heading">
            Рублевое пополнение {replenishment.id ? `№${replenishment.id}` : ""} на основании запроса №
            {replenishment.clientRequestId}
          </h1>
          <ul className="deal-stage-list">
            <li className={`deals-stage-item${stage === "BASIS" ? "-active" : ""}`} onClick={() => setStage("BASIS")}>
              Основание
            </li>
            <li
              className={getItemClazz("CONTRACTOR")}
              style={!isPickable("CONTRACTOR") ? { pointerEvents: "none" } : {}}
              onClick={() => (isPickable("CONTRACTOR") ? setStage("CONTRACTOR") : void 0)}
            >
              Контрагент
            </li>
            <li
              className={getItemClazz("DOCS")}
              style={!isPickable("DOCS") ? { pointerEvents: "none" } : {}}
              onClick={() => (isPickable("DOCS") ? setStage("DOCS") : void 0)}
            >
              Документы
            </li>
            <li
              className={getItemClazz("CR")}
              style={!isPickable("CR") ? { pointerEvents: "none" } : {}}
              onClick={() => (isPickable("CR") ? setStage("CR") : void 0)}
            >
              Запрос курса
            </li>
            <li
              className={getItemClazz("PAYMENT")}
              style={!isPickable("PAYMENT") ? { pointerEvents: "none" } : {}}
              onClick={() => (isPickable("PAYMENT") ? setStage("PAYMENT") : void 0)}
            >
              Оплата
            </li>
            <li
              className={getItemClazz("CR_FIX")}
              style={!isPickable("CR_FIX") ? { pointerEvents: "none" } : {}}
              onClick={() => (isPickable("CR_FIX") ? setStage("CR_FIX") : void 0)}
            >
              Фиксация курса
            </li>
          </ul>
        </div>

        {stage === "BASIS" && (
          <BasisTab
            replenishment={replenishment}
            setReplenishment={setReplenishment}
            errorModel={errors}
            sending={sending}
            submit={submitBasis}
          />
        )}
        {stage === "CONTRACTOR" && (
          <ContractorTab
            replenishment={replenishment}
            setReplenishment={setReplenishment}
            errorModel={errors}
            sending={sending}
            submit={submitContractor}
          />
        )}
        {stage === "DOCS" && (
          <DocsTab
            replenishment={replenishment}
            setReplenishment={setReplenishment}
            errorModel={errors}
            sending={sending}
            submit={submitDocs}
          />
        )}
        {stage === "CR" && (
          <CRTab replenishment={replenishment} setReplenishment={setReplenishment} crAcceptance={crAcceptance} />
        )}
        {stage === "PAYMENT" || (stage === "CR_FIX" && replenishment.status !== "DONE") ? (
          <PaymentTab
            replenishment={replenishment}
            setReplenishment={setReplenishment}
            errorModel={errors}
            sending={sending}
            submit={submitBill}
            reject={rejectPayment}
          />
        ) : (
          <></>
        )}
        {stage === "CR_FIX" && replenishment.status === "DONE" && (
          <CRTab
            replenishment={replenishment}
            setReplenishment={setReplenishment}
            crAcceptance={crAcceptance}
            showFixed={true}
          />
        )}
      </section>
    </>
  )
}
